module.exports = __webpack_public_path__ + "img/icon_manejo_solicitudes_materiales_y_equipos.6ad5d56a.svg";